/* eslint-disable no-undef */

export default {
	name: "email-query-modal",
	data() {
		return {
			messageTypes: [],
			selectedMessageType: {
				messageTypeId: null,
				messageType: null
			},
			message: {
				value: null,
				hasError: false,
				errorMessage: null
			},
			loading: false,
			modalId: "sendEmailQueryModal"
		};
	},
	methods: {
		getMessageTypes(){
			notificationService.getMessageTypes().then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.messageTypes = successResponse.data.result;
						this.messageTypes = $.map(this.messageTypes,
							function (obj) {
								obj.id = obj.id || obj.messageTypeId;
								obj.text = obj.text || obj.name;
								return obj;
							});
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onModalCloseClick(){
			$("#" + this.modalId).modal("hide");
		},
		onMessageTypeSelect(selectedMessageType){
			this.selectedMessageType.messageTypeId = selectedMessageType.id;
			this.selectedMessageType.messageType = selectedMessageType.text;
		},
		sendQueryEmail(){
			this.loading = true;
			let request = {
				messageTypeId: this.selectedMessageType.messageTypeId === null ? 0 : this.selectedMessageType.messageTypeId,
				messageType: this.selectedMessageType.messageType,
				message: this.message.value
			};
			customerService.sendEmailQueryToAdminUserOnBehalfOfCustomerUser(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.messageValidationResponse.hasError){
							this.message.hasError = true;
							this.message.errorMessage = successResponse.data.messageValidationResponse.message;
						}
						else{
							this.message.hasError = false;
							$("#" + this.modalId).modal("hide");
						}
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					this.loading = false;
				}
			);
		}
	},
	mounted: function () {
        this.getMessageTypes();
	}
};
